import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Grid = styled.div`
  position: relative;
  margin: 40px auto;
  max-width: ${themeGet('media.grid')};
  // * calc(100% - 30px) gives us 15px margin on the left and right of the grid container on a mobile view
  width: calc(100% - ${themeGet('media.grid-gutter.2')});
  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    width: calc(100% - ${themeGet('media.grid-gutter.3')});
  }
  // * calc(100% - 60px) gives us 30px margin on the left and right of the grid container on a tablet view
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: calc(100% - ${themeGet('media.grid-gutter.3')});
    margin: 70px auto;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin: 100px auto;
  }

  &.auto-margin {
    margin: 0 auto;
  }

  &.no-margin {
    margin: 0 !important;
  }

  &.inner-container {
    margin: 40px 0;
    width: 100%;
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin: 70px 0;
    }
    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      margin: 100px 0;
    }
  }
`;
